import type { PowerBallParticipation } from '../../../types';
import { extractBaseWinnings, registerCalculator, type WinningsCalculationData } from './calculators';

/**
 * PowerBall winnings calculator.
 * Applies PowerPlay multiplier when powerPlay option is enabled.
 */
function calculatePowerBallWinnings({ participation, options, currency }: WinningsCalculationData): number {
  const { powerGames } = participation as PowerBallParticipation;
  const multiplier = options?.includes('powerPlay') ? (powerGames?.multiplier ?? 1) : 1;
  const winnings = extractBaseWinnings(participation.lineWinningInfo, currency);

  return winnings.reduce((sum: number, value: number) => sum + value * multiplier, 0);
}

registerCalculator('powerBall', calculatePowerBallWinnings);

export { calculatePowerBallWinnings };
